/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetInformationByIdDto } from '../models/custom-result-of-get-information-by-id-dto';
import { CustomResultOfGetInformationDetailForSendSmsDto } from '../models/custom-result-of-get-information-detail-for-send-sms-dto';
import { CustomResultOfListOfGetInformationsFoDashboardDto } from '../models/custom-result-of-list-of-get-informations-fo-dashboard-dto';
import { CustomResultOfPaginatedListOfGetInformationUsersSeenListDto } from '../models/custom-result-of-paginated-list-of-get-information-users-seen-list-dto';
import { CustomResultOfPaginatedListOfGetInformationWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-information-with-pagination-dto';
import { informationsAddCurrentUserToInformationSeen } from '../fn/informations/informations-add-current-user-to-information-seen';
import { InformationsAddCurrentUserToInformationSeen$Params } from '../fn/informations/informations-add-current-user-to-information-seen';
import { informationsCreateGet } from '../fn/informations/informations-create-get';
import { InformationsCreateGet$Params } from '../fn/informations/informations-create-get';
import { informationsCreateNewSmsInformationForOrganizations } from '../fn/informations/informations-create-new-sms-information-for-organizations';
import { InformationsCreateNewSmsInformationForOrganizations$Params } from '../fn/informations/informations-create-new-sms-information-for-organizations';
import { informationsCreatePost } from '../fn/informations/informations-create-post';
import { InformationsCreatePost$Params } from '../fn/informations/informations-create-post';
import { informationsDelete } from '../fn/informations/informations-delete';
import { InformationsDelete$Params } from '../fn/informations/informations-delete';
import { informationsGetInformationDetailForSendSms } from '../fn/informations/informations-get-information-detail-for-send-sms';
import { InformationsGetInformationDetailForSendSms$Params } from '../fn/informations/informations-get-information-detail-for-send-sms';
import { informationsGetInformationsAuditWithPagination } from '../fn/informations/informations-get-informations-audit-with-pagination';
import { InformationsGetInformationsAuditWithPagination$Params } from '../fn/informations/informations-get-informations-audit-with-pagination';
import { informationsGetInformationsForDashboard } from '../fn/informations/informations-get-informations-for-dashboard';
import { InformationsGetInformationsForDashboard$Params } from '../fn/informations/informations-get-informations-for-dashboard';
import { informationsGetInformationsWithPagination } from '../fn/informations/informations-get-informations-with-pagination';
import { InformationsGetInformationsWithPagination$Params } from '../fn/informations/informations-get-informations-with-pagination';
import { informationsGetInformationUsersSeenList } from '../fn/informations/informations-get-information-users-seen-list';
import { InformationsGetInformationUsersSeenList$Params } from '../fn/informations/informations-get-information-users-seen-list';
import { informationsUpdateGet } from '../fn/informations/informations-update-get';
import { InformationsUpdateGet$Params } from '../fn/informations/informations-update-get';
import { informationsUpdatePut } from '../fn/informations/informations-update-put';
import { InformationsUpdatePut$Params } from '../fn/informations/informations-update-put';

@Injectable({ providedIn: 'root' })
export class InformationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `informationsCreateGet()` */
  static readonly InformationsCreateGetPath = '/Informations/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  informationsCreateGet$Response(params?: InformationsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return informationsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  informationsCreateGet(params?: InformationsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.informationsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `informationsCreatePost()` */
  static readonly InformationsCreatePostPath = '/Informations/Create';

  /**
   * Create New Information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsCreatePost$Response(params: InformationsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return informationsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create New Information.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsCreatePost(params: InformationsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.informationsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `informationsUpdatePut()` */
  static readonly InformationsUpdatePutPath = '/Informations/Update';

  /**
   * Update An Existing Information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsUpdatePut$Response(params: InformationsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return informationsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update An Existing Information.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsUpdatePut(params: InformationsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.informationsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `informationsUpdateGet()` */
  static readonly InformationsUpdateGetPath = '/Informations/Update/{id}';

  /**
   * Get Information By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  informationsUpdateGet$Response(params: InformationsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetInformationByIdDto>> {
    return informationsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Information By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  informationsUpdateGet(params: InformationsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetInformationByIdDto> {
    return this.informationsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetInformationByIdDto>): CustomResultOfGetInformationByIdDto => r.body)
    );
  }

  /** Path part for operation `informationsDelete()` */
  static readonly InformationsDeletePath = '/Informations';

  /**
   * Delete An Existing Information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  informationsDelete$Response(params?: InformationsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return informationsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete An Existing Information.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  informationsDelete(params?: InformationsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.informationsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `informationsGetInformationsWithPagination()` */
  static readonly InformationsGetInformationsWithPaginationPath = '/Informations/GetInformationsWithPagination';

  /**
   * Get Informations With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsGetInformationsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsGetInformationsWithPagination$Response(params: InformationsGetInformationsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetInformationWithPaginationDto>> {
    return informationsGetInformationsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Informations With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsGetInformationsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsGetInformationsWithPagination(params: InformationsGetInformationsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetInformationWithPaginationDto> {
    return this.informationsGetInformationsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetInformationWithPaginationDto>): CustomResultOfPaginatedListOfGetInformationWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `informationsGetInformationUsersSeenList()` */
  static readonly InformationsGetInformationUsersSeenListPath = '/Informations/GetInformationUsersSeenList';

  /**
   * دریافت لیست کاربرانی که یک خبر را مشاهده کرده اند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsGetInformationUsersSeenList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsGetInformationUsersSeenList$Response(params: InformationsGetInformationUsersSeenList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetInformationUsersSeenListDto>> {
    return informationsGetInformationUsersSeenList(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست کاربرانی که یک خبر را مشاهده کرده اند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsGetInformationUsersSeenList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsGetInformationUsersSeenList(params: InformationsGetInformationUsersSeenList$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetInformationUsersSeenListDto> {
    return this.informationsGetInformationUsersSeenList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetInformationUsersSeenListDto>): CustomResultOfPaginatedListOfGetInformationUsersSeenListDto => r.body)
    );
  }

  /** Path part for operation `informationsGetInformationsForDashboard()` */
  static readonly InformationsGetInformationsForDashboardPath = '/Informations/GetInformationsForDashboard';

  /**
   * Get Informations For Dashboard.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsGetInformationsForDashboard()` instead.
   *
   * This method doesn't expect any request body.
   */
  informationsGetInformationsForDashboard$Response(params?: InformationsGetInformationsForDashboard$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetInformationsFoDashboardDto>> {
    return informationsGetInformationsForDashboard(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Informations For Dashboard.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsGetInformationsForDashboard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  informationsGetInformationsForDashboard(params?: InformationsGetInformationsForDashboard$Params, context?: HttpContext): Observable<CustomResultOfListOfGetInformationsFoDashboardDto> {
    return this.informationsGetInformationsForDashboard$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetInformationsFoDashboardDto>): CustomResultOfListOfGetInformationsFoDashboardDto => r.body)
    );
  }

  /** Path part for operation `informationsGetInformationsAuditWithPagination()` */
  static readonly InformationsGetInformationsAuditWithPaginationPath = '/Informations/GetInformationsAuditWithPagination';

  /**
   * Get Informations Audit With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsGetInformationsAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsGetInformationsAuditWithPagination$Response(params: InformationsGetInformationsAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return informationsGetInformationsAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Informations Audit With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsGetInformationsAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsGetInformationsAuditWithPagination(params: InformationsGetInformationsAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.informationsGetInformationsAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `informationsAddCurrentUserToInformationSeen()` */
  static readonly InformationsAddCurrentUserToInformationSeenPath = '/Informations/AddCurrentUserToInformationSeen';

  /**
   * افزودن کاربر فعلی به لیست خوانده شده های یک خبر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsAddCurrentUserToInformationSeen()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsAddCurrentUserToInformationSeen$Response(params: InformationsAddCurrentUserToInformationSeen$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return informationsAddCurrentUserToInformationSeen(this.http, this.rootUrl, params, context);
  }

  /**
   * افزودن کاربر فعلی به لیست خوانده شده های یک خبر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsAddCurrentUserToInformationSeen$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsAddCurrentUserToInformationSeen(params: InformationsAddCurrentUserToInformationSeen$Params, context?: HttpContext): Observable<CustomResult> {
    return this.informationsAddCurrentUserToInformationSeen$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `informationsCreateNewSmsInformationForOrganizations()` */
  static readonly InformationsCreateNewSmsInformationForOrganizationsPath = '/Informations/CreateNewSmsInformationForOrganizations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsCreateNewSmsInformationForOrganizations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsCreateNewSmsInformationForOrganizations$Response(params: InformationsCreateNewSmsInformationForOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return informationsCreateNewSmsInformationForOrganizations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsCreateNewSmsInformationForOrganizations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informationsCreateNewSmsInformationForOrganizations(params: InformationsCreateNewSmsInformationForOrganizations$Params, context?: HttpContext): Observable<CustomResult> {
    return this.informationsCreateNewSmsInformationForOrganizations$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `informationsGetInformationDetailForSendSms()` */
  static readonly InformationsGetInformationDetailForSendSmsPath = '/Informations/GetInformationDetailForSendSms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informationsGetInformationDetailForSendSms()` instead.
   *
   * This method doesn't expect any request body.
   */
  informationsGetInformationDetailForSendSms$Response(params?: InformationsGetInformationDetailForSendSms$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetInformationDetailForSendSmsDto>> {
    return informationsGetInformationDetailForSendSms(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informationsGetInformationDetailForSendSms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  informationsGetInformationDetailForSendSms(params?: InformationsGetInformationDetailForSendSms$Params, context?: HttpContext): Observable<CustomResultOfGetInformationDetailForSendSmsDto> {
    return this.informationsGetInformationDetailForSendSms$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetInformationDetailForSendSmsDto>): CustomResultOfGetInformationDetailForSendSmsDto => r.body)
    );
  }

}
